import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { UserProfile } from '../user/UserProfile'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ChatSenderInput')
export class ChatSender {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('csnd') })
  _id?: string

  @Field(() => UserProfile)
  @Prop({ type: UserProfile })
  profile: UserProfile
}
